/**
 * Build the data object for creating the next season.
 *
 * Pure function — no hooks, no side effects.
 *
 * @param {Object} params
 * @param {string} params.farmId - Farm organization ID
 * @param {number} params.currentYear - The year of the season being ended
 * @returns {Object} Season insert payload
 */
export const buildNextSeason = ({ farmId, currentYear }) => ({
  organization_id: farmId,
  year: currentYear + 1,
  state: 'active',
  started_at: new Date().toISOString(),
})
